export default __webpack_public_path__ + "static/media/team71.cebdc179.JPG";